"use client";

import React from "react";
import { ShieldCheck } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
const milestones = [{
  year: "2012",
  title: "Gründung von SecureNetics",
  description: "Start als spezialisierte Beratung für Netzwerksicherheit mit dem Ziel, digitale Infrastrukturen gegen aufkommende Cyber-Bedrohungen zu härten."
}, {
  year: "2015",
  title: "Enterprise Security Framework",
  description: "Entwicklung ganzheitlicher Sicherheitsstrategien für Großunternehmen und Implementierung der ersten komplexen Intrusion Detection Systeme."
}, {
  year: "2018",
  title: "Zertifizierte Exzellenz",
  description: "Akkreditierung als führender Partner für kritische Infrastrukturen und Ausbau unseres Teams aus hochspezialisierten Sicherheitsanalysten."
}, {
  year: "2021",
  title: "Next-Gen SOC Launch",
  description: "Inbetriebnahme unseres modernen Security Operations Center zur Echtzeit-Überwachung und proaktiven Abwehr von Zero-Day-Exploits."
}, {
  year: "2024",
  title: "KI-gestützte Verteidigung",
  description: "Integration fortschrittlicher Machine-Learning-Algorithmen zur automatisierten Erkennung von Anomalien in globalen Netzwerken."
}];
function TimelineItem({
  item,
  i,
  isLast
}: {
  item: (typeof milestones)[0];
  i: number;
  isLast: boolean;
}) {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <div data-index={i} ref={ref} className={`flex group transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
      {}
      <div className="w-20 sm:w-32 shrink-0 text-right pt-1.5 pr-4 sm:pr-6">
        <span className="font-mono text-xl sm:text-2xl font-bold text-primary tracking-wider">
          {item.year}
        </span>
      </div>

      {}
      <div className="flex-1 pl-6 sm:pl-8 pb-12 sm:pb-16">
        <Card className="bg-card/30 backdrop-blur-md border-border/40 shadow-lg hover:shadow-primary/10 transition-all duration-300 hover:bg-card/50 hover:border-primary/30">
          <CardHeader className="pb-3">
            <CardTitle className="text-lg sm:text-xl font-default font-bold text-foreground tracking-tight">
              {item.title}
            </CardTitle>
          </CardHeader>
          <CardContent>
            <CardDescription className="text-base text-muted-foreground leading-relaxed font-sans">
              {item.description}
            </CardDescription>
          </CardContent>
        </Card>
      </div>
    </div>;
}
export default function MilestonesOfIntegrity() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return;
}